import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FEATURE_TOGGLE_SETTINGS } from "../../config";
import * as settingsActions from "../../store/actions/permissions.js";
import "./style.css";
import FormSettings from "./form";
import HeaderContent from "../headerContent";
import SettingsSummaryTable from "./settings-summary-table";
import SettingsViewHandler from "./settings-view-handler";

class Settings extends Component {
  static propTypes = {
    location: PropTypes.any,
    navigate: PropTypes.any,
    accountantSelected: PropTypes.string,
    accountantIdSelected: PropTypes.string,
    accountantUuidSelected: PropTypes.string,
    companyUuidSelected: PropTypes.string,
    userUuidSelected: PropTypes.string,
    auth: PropTypes.object,
    companySelected: PropTypes.string,
    clientIdSelected: PropTypes.string,
    currentPermissions: PropTypes.object,
    getPermissionsClientsList: PropTypes.func,
    loadCompanyForSettings: PropTypes.func,
    getSettingsCompany: PropTypes.func,
    savePermissions: PropTypes.func,
    hasMoreItems: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 20,
      page: 1,
      companyChosenList: [props.companyUuidSelected],
      settings: props.currentPermissions.permissionClient.permissions /** il default  */,
      settingsToSave: [],
      companiesSize: 40,
      companiesLoaded: props.companiesLoaded,
      changeInSettings: false,
      selectedView: "edit",
    };
  }

  companiesLoad(page, searchTerm = "") {
    const { accountantIdSelected, companiesLoaded, loadCompanyForSettings } = this.props;
    const { companiesSize } = this.state;
    loadCompanyForSettings(searchTerm, page, companiesSize, companiesLoaded, accountantIdSelected);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { currentPermissions } = nextProps;
    let arrayCompaniesChosen = prevState.companyChosenList;
    if (!prevState.companyChosenList.includes(nextProps.companyUuidSelected)) {
      arrayCompaniesChosen.push(nextProps.companyUuidSelected);
    }
    if (currentPermissions.permissionClient && currentPermissions.companySettingsList.companies !== prevState.companiesLoaded) {
      return {
        companiesLoaded: currentPermissions.companySettingsList.companies,
      };
    }
    if (currentPermissions.permissionClient && currentPermissions.permissionClient.permissions !== prevState.settings) {
      return {
        companyChosenList: arrayCompaniesChosen,
        settings: nextProps.currentPermissions.permissionClient.permissions,
        settingsToSave: [],
      };
    }
    return prevState;
  }

  componentDidMount() {
    const { accountantUuidSelected, getPermissionsClientsList, company } = this.props;
    if (company.companies && !company.hasMoreItems) {
      getPermissionsClientsList(accountantUuidSelected);
    }
  }

  async componentDidUpdate(prevProps) {
    const { accountantUuidSelected, currentPermissions, getPermissionsClientsList, getSettingsCompany, company } = this.props;
    if (currentPermissions.isPermissionsSaved !== prevProps.currentPermissions.isPermissionsSaved && company.companies && !company.hasMoreItems) {
      getPermissionsClientsList(accountantUuidSelected);

      getSettingsCompany();
      this.companiesLoad(0, "");
    }
  }

  changeView(view) {
    this.setState({
      selectedView: view,
    });
  }

  changePage(current, size) {
    this.setState({
      page: current,
    });
  }

  paginate(array, page_size, page_number) {
    --page_number; // because pages logically start with 1, but technically with 0
    return array.slice(page_number * page_size, (page_number + 1) * page_size);
  }

  getCompanyId(arrayList, companyUuid) {
    return arrayList.find((client) => {
      return client.permissions[0].itemId === companyUuid;
    });
  }

  getCodiceFiscale(arrayList, uuid) {
    return arrayList.find((el) => {
      return el.uuid === uuid;
    });
  }

  async handleChangeMultiple(_, value) {
    const { settings } = this.state;
    const { accountantUuidSelected, userUuidSelected } = this.props;

    const customers = value.map((el) => el.key);

    const oldPermissions = settings.map((set) => set.permissions);

    const oldPermissionsFlatten = oldPermissions.flatMap((x) => {
      return x.map((y) => {
        return {
          name: y.functionName,
          isActive: y.isActive,
        };
      });
    });

    let arraySettingsToSave = [];
    let currentSettings = {};

    for (let ch = 0; ch < customers.length; ch++) {
      currentSettings[ch] = {
        ownerId: accountantUuidSelected ? accountantUuidSelected : "",
        permissions: [
          {
            itemId: customers[ch],
            userId: userUuidSelected ? userUuidSelected : null,
            actions: [],
          },
        ],
      };

      currentSettings[ch].permissions[0].actions = [...oldPermissionsFlatten];
    }

    arraySettingsToSave.push(Object.values(currentSettings));

    this.setState({
      companyChosenList: customers,
      settingsToSave: arraySettingsToSave.flat(),
    });
  }

  changeToggle(indexGroup, indexFunction, functionName, value) {
    const { accountantUuidSelected, userUuidSelected } = this.props;
    const { settings, settingsToSave, companyChosenList } = this.state;
    let arraySettingsToSave = [];

    let currentSettings = settingsToSave;

    for (let ch = 0; ch < companyChosenList.length; ch++) {
      if (!currentSettings[ch]) {
        currentSettings[ch] = {
          ownerId: accountantUuidSelected ? accountantUuidSelected : "",
          permissions: [
            {
              itemId: companyChosenList[ch],
              userId: userUuidSelected ? userUuidSelected : null,
              actions: [],
            },
          ],
        };
      }

      currentSettings[ch].permissions[0].actions.push({
        name: functionName,
        isActive: value ? true : false,
      });

      currentSettings[ch].permissions[0].actions = [
        ...currentSettings[ch].permissions[0].actions.reverse().filter((action, index, self) => index === self.findIndex((a) => a.name === action.name)),
      ];
    }

    let arraySettings = settings;

    arraySettings[indexGroup].permissions[indexFunction].isActive = value ? true : false;

    arraySettingsToSave.push(currentSettings);

    this.setState({
      settings: arraySettings,
      settingsToSave: arraySettingsToSave.flat(),
      changeInSettings: true,
    });
  }

  openSuccessWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
      duration: 8,
      style: { marginTop: "50px" },
    });
  };

  checkPermissionSaved() {
    const { currentPermissions } = this.props;
    if (currentPermissions.isPermissionsSaved) {
      this.openSuccessWithIcon("success", "Impostazioni salvate correttamente", "Le impostazioni sono state salvate correttamente.");
      return;
    }
    if (currentPermissions.isPermissionsError) {
      this.openSuccessWithIcon("error", "Si è verificato un problema", "Le impostazioni non sono state salvate correttamente.");
      return;
    }

    setTimeout(
      function () {
        this.checkPermissionSaved();
      }.bind(this),
      100
    );
  }

  async resetAll() {
    this.setState({
      changeInSettings: false,
    });
    const { accountantUuidSelected, getSettingsCompany, getPermissionsClientsList, company } = this.props;

    getSettingsCompany().then(company.companies && !company.hasMoreItems ? () => getPermissionsClientsList(accountantUuidSelected) : null);
    this.companiesLoad(0, "");
  }

  async saveAll() {
    const { savePermissions } = this.props;
    const { companyChosenList, settingsToSave } = this.state;

    if (settingsToSave.length === 0) {
      this.openSuccessWithIcon("error", "Si è verificato un problema", "Le impostazioni non sono state salvate correttamente.");
      return;
    }

    this.setState({
      changeInSettings: false,
    });
    let arrayClientSettingsToSave = [];
    let self = this;
    for (let comp = 0; comp < companyChosenList.length; comp++) {
      let currentClientSettings = self.getCompanyId(settingsToSave, companyChosenList[comp]);
      arrayClientSettingsToSave.push(currentClientSettings);
    }
    if (arrayClientSettingsToSave !== undefined) {
      for (let clientSettings = 0; clientSettings < arrayClientSettingsToSave.length; clientSettings++) {
        savePermissions([arrayClientSettingsToSave[clientSettings]], arrayClientSettingsToSave[clientSettings].permissions[0].itemId);
      }
    }
    this.checkPermissionSaved();
    this.setState({
      companyChosenList: [],
    });
  }

  filterOption(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  render() {
    const {
      clientIdSelected,
      currentPermissions: { permissionClientsList, isGettingPermissionsCompanies },
      companyUuidSelected,
    } = this.props;
    const { companyChosenList } = this.state;
    const customStyle = FEATURE_TOGGLE_SETTINGS === "true" ? "settingsPageContainer" : "contentStructure settings moreSpace";

    return (
      <div className={customStyle}>
        {FEATURE_TOGGLE_SETTINGS !== "true" && (
          <HeaderContent location={this.props.location} title={"IMPOSTAZIONI"} subtitle={"Il tuo studio"} navigate={navigate} />
        )}
        <SettingsViewHandler changeView={this.changeView.bind(this)} selectedView={this.state.selectedView} />
        {this.state.selectedView === "edit" ? (
          <FormSettings
            changeToggle={this.changeToggle.bind(this)}
            clientIdSelected={clientIdSelected}
            companiesLoaded={this.state.companiesLoaded}
            companiesLoad={this.companiesLoad.bind(this)}
            companyChosenList={companyChosenList}
            handleChangeMultiple={this.handleChangeMultiple.bind(this)}
            companyUuidSelected={companyUuidSelected}
            open={true}
            resetAll={this.resetAll.bind(this)}
            saveAll={this.saveAll.bind(this)}
            settings={this.state.settings}
            changeInSettings={this.state.changeInSettings}
          />
        ) : (
          <div className="summaryContainer">
            {permissionClientsList && !isGettingPermissionsCompanies ? (
              <div>
                <SettingsSummaryTable />
              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <FontAwesomeIcon icon={["far", "circle-notch"]} spin style={{ color: "#46a5db", fontSize: "50px" }} />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    companiesLoaded: state.currentPermissions.companySettingsList.companies,
    hasMoreItems: state.currentPermissions.companySettingsList.hasMoreItems,
    company: state.company,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPermissionsClientsList: bindActionCreators(settingsActions.getPermissionsClientsList, dispatch),
    loadCompanyForSettings: bindActionCreators(settingsActions.loadCompanyForSettings, dispatch),
    clearSearchedCompanyForSettings: bindActionCreators(settingsActions.clearSearchedCompanyForSettings, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
